module.exports = __webpack_public_path__ + "static/media/telegram_logo.2a3421c8.png";